import React, { useState, useRef } from "react";
import { useAuth } from "../Auth/AuthContext/AuthContext";
import LoginButton from "../Auth/Login/LoginButton";
import { useNavigate } from "react-router-dom";

const UserAvatar = () => {
  const { logout, userData, isLoadingUserData } = useAuth(); // Dados do usuário do contexto
  const navigate = useNavigate();
  const [isCardOpen, setIsCardOpen] = useState(false); // Controle do card
  const cardRef = useRef(null); // Referência para fechar o card

  // Fechar o card ao clicar fora
  const handleClickOutside = (event) => {
    if (cardRef.current && !cardRef.current.contains(event.target)) {
      setIsCardOpen(false);
    }
  };

  // Alternar visibilidade do card
  const toggleCard = () => setIsCardOpen(!isCardOpen);

  // Lógica de logout
  const handleLogout = () => {
    logout(); // Faz logout
    setIsCardOpen(false);
    navigate("/"); // Redireciona para a página inicial
  };

  // Adicionar evento para fechar o card ao clicar fora
  React.useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative">
      {/* Avatar do usuário ou ícone padrão */}
      {isLoadingUserData ? (
        <div className="w-10 h-10 bg-gray-300 rounded-full animate-pulse"></div>
      ) : (
        <div onClick={toggleCard} className="cursor-pointer">
          {userData?.user?.photo ? (
            <img
              src={`data:image/jpeg;base64,${userData.user.photo}`}
              alt="User Avatar"
              className="w-10 h-10 rounded-full"
            />
          ) : (
            <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center">
              ?
            </div>
          )}
        </div>
      )}

      {/* Card com os detalhes do usuário */}
      {isCardOpen && (
        <div
          ref={cardRef}
          className="absolute right-0 mt-2 w-64 bg-white shadow-lg rounded-lg border border-gray-200 p-4 z-50"
        >
          {userData ? (
            <div className="flex flex-col items-center">
              {userData.user.photo && (
                <img
                  src={`data:image/jpeg;base64,${userData.user.photo}`}
                  alt="User Avatar"
                  className="w-16 h-16 rounded-full mb-2"
                />
              )}
              <p className="text-lg font-semibold">{userData.user.displayName}</p>
              <p className="text-sm text-gray-600">{userData.user.email}</p>
              <p className="text-xs pb-2 text-center text-gray-400 mt-1">{userData.user.id}</p>
            </div>
          ) : (
            <div className="text-center text-gray-600">
              <p>Usuário não logado</p>
              <p>Faça login para acessar seus dados.</p>
            </div>
          )}
          <div className="flex justify-center mx-5">
            <LoginButton onLogout={handleLogout} />
          </div>
        </div>
      )}
    </div>
  );
};

export default UserAvatar;
